import CandidaturePreviewRequest from "../../../api/raily/candidature/preview/candidature-preview.request";
import CandidaturePreviewParams from "./candidature-preview-params";

const create = (
  params: CandidaturePreviewParams,
): CandidaturePreviewRequest => {
  return {
    orderId: params.orderUuid,
    taxiDriverAssociationId: params.taxiDriverAssociationUuid,
    planEntryId: params.planEntryUuid,
  };
};

const candidaturePreviewParamsFactory = {
  create,
};

export default candidaturePreviewParamsFactory;
